import React, { useState, useEffect } from "react";
import useFormDataPost from "../../services/useFormDataPost";

const ImageUploader = ({ subdir, onImageUpload, imageUrl }) => {
  const [previewImage, setPreviewImage] = useState(null);
  const [imageUploading, setImageUploading] = useState(false);
  const { postFormData, formDataPostResult, formDataPostError } =
    useFormDataPost();

    console.log(previewImage,'..')

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) {
      setPreviewImage(null);
      return;
    }

    // Preview Image
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => setPreviewImage(reader.result);

    // Upload Image
    let formData = new FormData();
    formData.append("file", file);

    setImageUploading(true);
    await postFormData(`images/upload?subdir=${subdir}`, formData);
  };

  // Handle API response
  useEffect(() => {
    if (formDataPostResult) {
      onImageUpload(formDataPostResult.filepath); // Send image URL back to parent
      setImageUploading(false);
    }
    if (formDataPostError) {
      console.log("Image Upload Failed:", formDataPostError);
      setImageUploading(false);
    }
  }, [formDataPostResult, formDataPostError]);

  return (
    <div>
      <label className="d-flex">
        <div className="browse_div">Choose File</div>
        <span className="browse_btn"></span>

        <input type="file" className="d-none" onChange={handleImageUpload} />
        <br />

        {
          (!previewImage && imageUrl) && (
            <img src={process.env.REACT_APP_LIVE_BASE_IMAGE_URL_LMS_ADMIN+imageUrl}
              style={{
                width: "5rem",
                height: "5rem",
                border: "1px dashed #d9d9d9",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "#f5f5f5",
                position: "relative",
              }}
            />
          )
        }

        {previewImage && (
          <div
            style={{
              width: "5rem",
              height: "5rem",
              border: "1px dashed #d9d9d9",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "#f5f5f5",
              position: "relative",
            }}
          >
            <div
              style={{
                width: "100%",
                height: "100%",
                position: "relative",
                border: "1px solid #ccc",
                borderRadius: "8px",
                overflow: "hidden",
              }}
              className={imageUploading ? "uploading" : "uploaded"}
            >
              <img
                src={previewImage}
                alt="Image"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  transition: "all 0.3s ease-in-out",
                  filter: imageUploading ? "blur(5px) brightness(0.9)" : "none",
                  opacity: imageUploading ? 0.6 : 1,
                }}
              />
              {imageUploading && (
                <div
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    color: "#fff",
                    padding: "10px 20px",
                    borderRadius: "5px",
                    fontSize: "14px",
                  }}
                >
                  Uploading...
                </div>
              )}
            </div>
          </div>
        )}
      </label>
    </div>
  );
};

export default ImageUploader;
